import { useEffect } from "react";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import { useAuth } from "../../hooks";
import { CheckCircleOutline } from "@mui/icons-material";
import AuthLayout from "../../layouts/AuthLayout";

const ResetPasswordSentPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const email = (location.state as any)?.email || "";

  useEffect(() => {
    // If user is already authenticated, redirect to home page
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }

    // If no email in state, redirect to request page
    if (!email) {
      navigate("/auth/reset-password-request", { replace: true });
    }
  }, [isAuthenticated, navigate, email]);

  return (
    <AuthLayout title="Check Your Email">
      <Box sx={{ textAlign: "center" }}>
        <CheckCircleOutline color="success" sx={{ fontSize: 60, mb: 2 }} />

        <Typography variant="body1" sx={{ mb: 3 }}>
          We've sent a password reset link to:
        </Typography>

        <Typography variant="body1" fontWeight="bold" sx={{ mb: 4 }}>
          {email}
        </Typography>

        <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
          If you don't see the email in your inbox, please check your spam
          folder. The link will expire in 30 minutes.
        </Typography>

        <Button
          component={RouterLink}
          to="/auth/login"
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
        >
          Return to Login
        </Button>
      </Box>
    </AuthLayout>
  );
};

export default ResetPasswordSentPage;
